import { useEffect, useState } from 'react';
import Datepicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { endToday, startToday } from 'src/utils/dateOneMonthAgo';

const DateRangePickerWithTime = (fetchData: any) => {
  const [startDate, setStartDate] = useState<any>(startToday());
  const [endDate, setEndDate] = useState<any>(endToday());
  const dateQuery = `from=${startDate?.toISOString()}&to=${endDate?.toISOString()}`;

  useEffect(() => {
    if (!startDate || !endDate) return;
    fetchData(`?${dateQuery}`);
  }, [startDate, endDate]);

  return (
    <div className="text-black flex flex-row items-center">
      <Datepicker
        name="date"
        className="w-[fit] appearance-none rounded-xl text-text-black
              placeholder:capitalize py-3 block placeholder:text-sm px-3 text-sm
               focus-within:outline-0 border-solid border border-primary"
        locale="en-US"
        selected={startDate}
        onChange={(date) => setStartDate(date)}
        startDate={startDate}
        endDate={endDate}
        selectsStart
        timeIntervals={15}
        showTimeSelect
        dateFormat="MMM d, yyyy h:mm aa"
        placeholderText="Select start date and time"
      />
      <span className="mx-1">-</span>
      <Datepicker
        name="date"
        className="w-[fit] appearance-none rounded-xl text-text-black
               placeholder:capitalize py-3 block placeholder:text-sm px-3 text-sm
                focus-within:outline-0 border-solid border border-primary"
        locale="en-US"
        selected={endDate}
        onChange={(date) => setEndDate(date)}
        selectsEnd
        startDate={startDate}
        endDate={endDate}
        minDate={startDate}
        showTimeSelect
        timeFormat="HH:mm"
        timeIntervals={15}
        timeCaption="Time"
        dateFormat="MMM d, yyyy h:mm aa"
        placeholderText="Select end date and time"
      />
    </div>
  );
};

export default DateRangePickerWithTime;
